module.exports = __webpack_public_path__ + "static/media/partners_shauna.17b9eed4.jpg";